import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { PATH_SGU } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastrarParametroSistemaRedisRequest } from './types';

// ACTIONS
import {
	cadastrarParametroSistemaRedisSuccess,
	cadastrarParametroSistemaRedisFailure,
} from './actions';

function* cadastrarParametroSistemaRedis(request: ReducerAction) {
	const { payload }: { payload: CadastrarParametroSistemaRedisRequest } =
		request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_SGU,
		`parametros-sistema-redis`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarParametroSistemaRedisSuccess(response));
	} else {
		yield put(cadastrarParametroSistemaRedisFailure());
	}
}

export default all([
	takeLatest(
		Types.CADASTRAR_PARAMETRO_SISTEMA_REDIS,
		cadastrarParametroSistemaRedis,
	),
]);
